
import React from "react";
import { useSelector } from "react-redux";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg"




export const EditGoodsInHeader = ({ RightSidebarOpenCloseFlag }) => {
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);


  return (
    <>
      <div className={`d-flex align-items-center main-header-div ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""}`} style={{ flex: 10 }}>
        <div style={{ flex: 1 }} className="ms-2">
          <img height={35} width={90} src={SigmaLogo} alt="muz image" />
        </div>
        <div style={{ flex: 9 }}>
          <span className="text-uppercase edit-header-text-style">Goods in record</span>
        </div>


      </div >
    </>
  );
}


